$(document).ready(function(){
	// Request a Repair : Product Issue (left side issue select)
	if(document.querySelectorAll('#step_product_issue').length == 0) return false; // GP Modify | 2019-11-25 | selector 수정

	symptoms = {
		el: document.getElementById("stepProductIssue"),
		$topicArea: null,
		modelNum: document.querySelector('input[name="modelNum"]'),
		modal: document.getElementById('modal_help_library'),
		modalNotice: document.getElementById('modalAgreeNotice'), // LGEAF-46
		modalCheckBeforeBooking : document.getElementById('modal_check_before_booking'), // LGECI-456
		modalLiveRemoteServiceNotice : document.getElementById('modalLiveRemoteServiceNotice'), // LGECI-932
		defaultParam: null,
		countrycode: document.getElementsByTagName("html")[0].getAttribute("data-countrycode"),
		init: function(){
			symptoms.$topicArea = $(symptoms.el); // 초기값

			symptoms.addTriggerEvent();
		},
		topicAreaInit: function(){
			var symptomsItems = symptoms.$topicArea.find("select");
			symptomsItems.not(":last").each(function(i) {
				var $select = $(this);
				var $nextSelect = symptomsItems.eq(i + 1);
				var $afterNextSelect = symptomsItems.eq(i + 2);

				if(!$select.hasClass("init")){
					$select.addClass("init");
				}else{
					return;
				}
				//LGCOMMON-11630 START
				if (symptomDepthSetupValue === 'N') {
				// LGECI-456 start
				$("#selectSubTopic").change(function(){
					if(symptoms.countrycode == "ca_en" || symptoms.countrycode == "ca_fr"){
						var sstdata = $('#selectSubTopic').attr('data-param').split('&');
						if(sstdata.indexOf("categoryId=CT20098040") != -1 || sstdata.indexOf("categoryId=CT20100041") != -1){
							var stT = $('#selectTopic option:selected').text();
							var sstT = $('#selectSubTopic option:selected').text();
							if((stT == "Cooling Issues" ||stT == "Dépannage: Refroidissement") && (sstT == "Pas de refroidissement" || sstT == "Not Cooling" )){
								symptoms.notCoolingIssueModal();
							}
						}
					}
				// LGECI-456 end
				})
				}else{
					$("#selectDetailTopic").change(function(){
						if(symptoms.countrycode == "ca_en" || symptoms.countrycode == "ca_fr"){
							var sstdata = $('#selectDetailTopic').attr('data-param').split('&');
							if(sstdata.indexOf("categoryId=CT20098040") != -1 || sstdata.indexOf("categoryId=CT20100041") != -1){
								var stT = $('#selectTopic option:selected').text();
								var sstT = $('#selectDetailTopic option:selected').text();
								if((stT == "Cooling Issues" ||stT == "Dépannage: Refroidissement") && (sstT == "Pas de refroidissement" || sstT == "Not Cooling" )){
									symptoms.notCoolingIssueModal();
								}
							}
						}
					})
				}
				//LGCOMMON-11630 END
				
				$select.drawAjaxOptions({
					setTarget: $nextSelect.get(0), 
					empty: function() {
						symptoms.$topicArea.find("#helpfulArticles").addClass('hidden');
						//LGCOMMON-11630 START
						if (symptomDepthSetupValue === 'N') {
							// LGEAF-46 start
							if($(this).attr("id") == "selectSubTopic" && $(symptoms.modalNotice).data("useinstallationflag") == "Y"){
								symptoms.installationNoticeModal();
							}
							// LGEAF-46 end
						}else{
							if($(this).attr("id") == "selectDetailTopic" && $(symptoms.modalNotice).data("useinstallationflag") == "Y"){
								symptoms.installationNoticeModal();
							}
						}
						//LGCOMMON-11630 END
					},
					notEmpty: function() {
						//LGCOMMON-11630 START
						if (symptomDepthSetupValue === 'N') {
							if($(this).attr("id") == "selectSubTopic"){
								symptoms.$topicArea.find("#helpfulArticles").removeClass('hidden');
							}else{
								symptoms.$topicArea.find("#helpfulArticles").addClass('hidden');
							}
						}else{
							if($(this).attr("id") == "selectDetailTopic"){
								symptoms.$topicArea.find("#helpfulArticles").removeClass('hidden');
							}else{
								symptoms.$topicArea.find("#helpfulArticles").addClass('hidden');
							}
						}
						//LGCOMMON-11630 END
					},
					callback: function(data) {
						$afterNextSelect.find('option:not(:first-child)').remove();
						$afterNextSelect.find('option:first-child').prop('selected', true);
						$afterNextSelect.attr('disabled', 'disabled');
						
						symptomsItems.each(function(j, item) {
							var param = symptoms.defaultParam + '&' + symptomsItems.not($(item)).serialize();
							$(item).attr('data-param', param).data('param', param);
						});

						$nextSelect.trigger('chosen:updated');
						$afterNextSelect.trigger('chosen:updated');
					},
					dynamicParam: true
				});
			});

			if(symptoms.countrycode != "br" && symptoms.countrycode != "mx"){ //LGEMS-366
				symptoms.addEvent();
			}else{
				symptoms.addEventBR();
			}
		},
		getModalData: function(obj){
			var el = obj.el;
			var url = el.getAttribute('data-url');
			var methodType = el.getAttribute('data-ajax-method') || "post";

			var param;
			var isBtnShow = obj.hasOwnProperty("isBtnShow") ? obj.isBtnShow : true;
			var dynamicParam = obj.hasOwnProperty("dynamicParam") ? obj.dynamicParam : false;
			var callbackFn = obj.hasOwnProperty("callbackFn") ? obj.callbackFn : function(){};

			if(dynamicParam) {
				param = $(el).attr("data-param") + "&" + xssfilter($(el).serialize());
			}else{
				param = xssfilter($(el).serialize());
			}

			if($(symptoms.modal).hasClass("show")){
				$(symptoms.modal).css("display","none");
			}

			// loading
			$('body').trigger('ajaxLoadBefore');

			ajax.noCacheCall(url, param, 'html', function(data){
				// loading
				$('body').trigger('ajaxLoadEnd');

				if(data){
					// var htmlStr = data.replace(/http:/g, "https:").replace(/<base([^>]+)>+/ig,"");
					var htmlStr = data.replace(/<base([^>]+)>+/ig,"");
					var $modalBody = $(symptoms.modal).find('.modal-body');
					var $modalFooter = $(symptoms.modal).find('.modal-footer');
					
					// custom scroll
					$modalBody.mCustomScrollbar('destroy');

					if(!$('.navigation').hasClass('mobile-device')) {
						$modalBody.html(htmlStr).mCustomScrollbar({
							theme:'dark'
						});
					} else {
						$modalBody.html(htmlStr).css('overflow-y', 'auto');
					}

					// modal footer area show/hide
					isBtnShow ? $modalFooter.show() : $modalFooter.hide();

					// modal data in modal tag
					var modalInModal = $modalBody.find('.modal');
					if(modalInModal){
						modalInModal.each(function(){
							!$modalBody.siblings("#"+$(this).attr("id")).length && $modalBody.after($(this).clone());
							$(this).remove();
						});
					}
					//LGCOMMON-11630 START
					if (symptomDepthSetupValue === 'N') {
						/* LGEBR-369 s*/
						if($(el).attr("id")=='selectSubTopic' && $modalBody.find('.article-symtom-list').find('.nodata').length > 0 && (symptoms.countrycode=='br'||symptoms.countrycode=='mx')){ //LGEMS-366
							return;
						}else{
							if(!$(symptoms.modal).hasClass("show")){
								$(symptoms.modal).modal('show');
							}else{
								$(symptoms.modal).css('display',"block");
							}
						}
						/* LGEBR-369 e*/
					}else{
						if($(el).attr("id")=='selectDetailTopic' && $modalBody.find('.article-symtom-list').find('.nodata').length > 0 && (symptoms.countrycode=='br'||symptoms.countrycode=='mx')){ //LGEMS-366
							return;
						}else{
							if(!$(symptoms.modal).hasClass("show")){
								$(symptoms.modal).modal('show');
							}else{
								$(symptoms.modal).css('display',"block");
							}
						}
					}
					//LGCOMMON-11630 END
					var requestUrl = url + "?" + param;
					callbackFn(requestUrl);
				}
			}, methodType);
		},
		addTriggerEvent: function(){
			$(symptoms.el).on({
				"symptoms:topicAreaInit": function(event, topicArea){
					symptoms.$topicArea = $(topicArea);
					symptoms.defaultParam = $(symptoms.el).attr("data-param");
					symptoms.topicAreaInit();
				}
			});
		},
		addEvent: function(){
			// helpfulArticles
			symptoms.$topicArea.off("change", "#helpfulArticles");
			symptoms.$topicArea.on({
				change: function(e){
					if(!$(this).get(0).value) { return };
					symptoms.getModalData({
						el: $(this).get(0),
						isBtnShow: true,
						dynamicParam: false,
						callbackFn: function(){
							initBoardView();
							initShareCommon();
							runPrint();
						}
					});
				}
			}, "#helpfulArticles");
			
			// LGEAF-46 start
			if( $(symptoms.modalNotice).data("useinstallationflag") == "Y"){
				$("#modal_help_library :button").on("click",function(){
					symptoms.installationNoticeModal();
				});
			}
			// LGEAF-46 end
			// LGECI-932 start
			if ($('#modalLiveRemoteServiceNotice').length) {
				$("#selectTopic").change(function(){
					var repairTeleSympcode = $('#modalLiveRemoteServiceNotice').attr("data-repairTeleSympcode");
					var repairTeleSympcodeArr = repairTeleSympcode.split(",");
					var thisVal = $(this).val();
					$.each(repairTeleSympcodeArr,function(i, item) {
						if(item == thisVal){
							symptoms.liveRemoteServiceNoticeModal();
							return;
						}
					});
				});
			}
			// LGECI-932 end
		},
		addEventBR: function(){
			//LGCOMMON-11630 START
			if (symptomDepthSetupValue === 'N') {
				// selectSubTopic
				symptoms.$topicArea.off("change", "#selectSubTopic");
				symptoms.$topicArea.on({
					change: function(e){
						if(!$(this).get(0).value) { return };
						symptoms.getModalData({
							el: $(this).get(0),
							isBtnShow: false,
							dynamicParam: true,
							callbackFn: function(requestUrl){
								$(symptoms.modal).find(".modal-footer .btn-secondary").attr("data-url", requestUrl);
							}
						});
					}
				}, "#selectSubTopic");
			}else{
				// selectDetailTopic
				symptoms.$topicArea.off("change", "#selectDetailTopic");
				symptoms.$topicArea.on({
					change: function(e){
						if(!$(this).get(0).value) { return };
						symptoms.getModalData({
							el: $(this).get(0),
							isBtnShow: false,
							dynamicParam: true,
							callbackFn: function(requestUrl){
								$(symptoms.modal).find(".modal-footer .btn-secondary").attr("data-url", requestUrl);
							}
						});
					}
				}, "#selectDetailTopic");
			}
			//LGCOMMON-11630 END

			// symtom list in link
			$(symptoms.modal).off("click", ".article-symtom-list li > a");
			$(symptoms.modal).on({
				click: function(e){
					e.preventDefault();
					symptoms.getModalData({
						el: $(this).get(0),
						isBtnShow: true,
						dynamicParam: false,
						callbackFn: function(){
							initBoardView();
							initShareCommon();
							runPrint();
						}
					});
				}
			}, ".article-symtom-list li > a");

			// helpfulArticles popup footer btn
			$(symptoms.modal).off("click", ".modal-footer .btn-secondary");
			$(symptoms.modal).on({
				click: function(e){
					e.preventDefault();
					symptoms.getModalData({
						el: $(this).get(0),
						isBtnShow: false,
						dynamicParam: false
					});
				}
			}, ".modal-footer .btn-secondary");
		},
		installationNoticeModal: function(){
			// LGEAF-46 start
			if( $(symptoms.modalNotice).modal()){
				$(symptoms.modalNotice).off("click");
				$(symptoms.modalNotice).on("click", ".modal-close, .modal-content #checkContinue", function(){
					if( $(symptoms.modalNotice).checkValidation({trigger:true})){
						$(symptoms.modalNotice).modal("hide");
					}
				});
			}
			// LGEAF-46 end
		},
		notCoolingIssueModal: function(){
			// LGECI-456 start
			if( $(symptoms.modalCheckBeforeBooking).modal()){
				$(symptoms.modalCheckBeforeBooking).off("click");
				$(symptoms.modalCheckBeforeBooking).on("click", ".modal-close, .modal-footer .btn-primary", function(){
						$(symptoms.modalCheckBeforeBooking).modal("hide");
				});
			}
			// LGECI-456 end
		},
		liveRemoteServiceNoticeModal: function(){
			// LGECI-932 start
			if( $(symptoms.modalLiveRemoteServiceNotice).modal()){
				$(symptoms.modalLiveRemoteServiceNotice).off("click");
				$(symptoms.modalLiveRemoteServiceNotice).on("click", ".modal-close", function(){
						$(symptoms.modalLiveRemoteServiceNotice).modal("hide");
				});
			}
			// LGECI-932 end
		}
	};

	symptoms.init();
});